import ResetPasswordContainer from "./ResetPasswordContainer";
import ResetPasswordStore from "./ResetPasswordStore";
export default ResetPasswordStore(ResetPasswordContainer);